import(/* webpackMode: "eager" */ "/app/conversations/6a75f65111d246064771d273/moah-ai-trader/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/conversations/6a75f65111d246064771d273/moah-ai-trader/frontend/src/components/ResponsibleTradingWarning.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/conversations/6a75f65111d246064771d273/moah-ai-trader/frontend/src/hooks/useAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TradingDataProvider"] */ "/app/conversations/6a75f65111d246064771d273/moah-ai-trader/frontend/src/hooks/useTradingData.tsx");
